import { createSlice } from "@reduxjs/toolkit";

import { SelectedService } from "../../ts/models/Event";
import Order from "../../ts/models/Order";

type InitialState = {
  selectedServiceProducts: SelectedService[];
  order: Order;
};

const initialState: InitialState = {
  selectedServiceProducts: [],
  order: { ...new Order() },
};

const order = createSlice({
  name: "order",
  initialState,
  reducers: {
    setServicesWithProducts: (state, action) => {
      state.selectedServiceProducts = action.payload;
    },
    removeServicesWithProducts: (state) => {
      state.selectedServiceProducts = initialState.selectedServiceProducts;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
    },
  },
});

export const orderActions = order.actions;

export default order.reducer;
